import React from "react";
import "./About.css";

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2>Sobre a Inti</h2>
        <p>
          Inspirada no deus Inca Inti, símbolo do sol e da renovação, nossa missão é iluminar o caminho das micro e
          pequenas empresas no Brasil, oferecendo soluções financeiras inovadoras e acessíveis.
        </p>
      </div>
    </section>
  );
}

export default About;
